import { createGlobalStyle } from 'styled-components'

/* istanbul ignore next */
export const GlobalStyle = createGlobalStyle`
  :root {
    --sidebarNavTransitionDuration: 0.3s;
  }

  *{
    font-family: 'Poppins', sans-serif;
  }

  html,
  body {
    height: 100vh;
    width: 100vw;
    line-height: 1.5;
    font-size: 14px;
  }

  header.chakra-modal__header svg {
    vertical-align: middle;
  }
  
  .mouse-select__frame {
    background: #569CD6;
    opacity: .2;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    position: fixed !important;
    max-width: 100vw;
    max-height: 100vh;
    z-index: 2;
  }
  .selected > a {
    border-color: var(--chakra-colors-appClearBlue)
  }
  .selected > td {
    background-color: var(--chakra-colors-appPaleGreyThree)
  }

`
